export type StyleTheme = 'light' | 'dark';
export type StyleFontSize = 'sm' | 'md' | 'lg';
export type StyleShadow = 'none' | 'soft' | 'medium' | 'strong';

export interface StyleSettingsConfig {
  cardRadius: number;
  buttonRadius: number;
  cardBorder: boolean;
  theme: StyleTheme;
  fontSize: StyleFontSize;
  shadow: StyleShadow;
}

export const STYLE_SETTINGS_STORAGE_KEY = 'dma-style-config';

export const DEFAULT_STYLE_SETTINGS: StyleSettingsConfig = {
  cardRadius: 14,
  buttonRadius: 8,
  cardBorder: true,
  theme: 'light',
  fontSize: 'md',
  shadow: 'soft',
};

export const STYLE_SHADOW_PRESETS: Record<StyleShadow, string> = {
  none: 'none',
  soft:
    '0 10px 28px -8px rgba(16, 24, 40, 0.14), 0 4px 12px -4px rgba(16, 24, 40, 0.08)',
  medium:
    '0 14px 36px -8px rgba(16, 24, 40, 0.2), 0 6px 16px -4px rgba(16, 24, 40, 0.12)',
  strong:
    '0 20px 48px -10px rgba(16, 24, 40, 0.28), 0 10px 24px -6px rgba(16, 24, 40, 0.16)',
};

/** Softer luminous shadows for dark surfaces */
export const STYLE_SHADOW_PRESETS_DARK: Record<StyleShadow, string> = {
  none: 'none',
  soft:
    '0 10px 28px -8px rgba(0, 0, 0, 0.45), 0 4px 12px -4px rgba(0, 0, 0, 0.35)',
  medium:
    '0 14px 36px -8px rgba(0, 0, 0, 0.55), 0 6px 16px -4px rgba(0, 0, 0, 0.4)',
  strong:
    '0 20px 48px -10px rgba(0, 0, 0, 0.65), 0 10px 24px -6px rgba(0, 0, 0, 0.5)',
};

export const STYLE_FONT_SCALE: Record<StyleFontSize, number> = {
  sm: 0.9,
  md: 1,
  lg: 1.1,
};
